import { PropsWithChildren } from 'react'
import styles from './index.module.scss'

export type MessageProps = PropsWithChildren<{}>

export const Message = ({ children }: MessageProps) => (
    <div className={styles.Message}>{children}</div>
)
